import React, { CSSProperties, FC, memo, ReactNode } from "react";
import { ActionsGroup, Flex, TitleText } from "@evergis/ui";

import { CloseDialogIcon } from "./CloseDialogIcon";

import {
  DialogTitle as DialogTitleContent,
  Icon,
  RestrictedWidthContainer,
  TitleContainer,
  CommonTitleContent,
  DialogTitleContainer,
} from "./styled";

import { useDialogContext } from "./FullScreenDialog";

export interface DialogTitleProps {
  titleText?: string | JSX.Element;
  extra?: ReactNode;
  extraActions?: ReactNode;
  extraTitle?: ReactNode;
  displayShadow?: boolean;
  style?: CSSProperties;
  className?: string;
}

export const DialogTitle: FC<DialogTitleProps> = memo(
  ({ titleText, displayShadow, extra, extraActions, extraTitle, style, className, children }) => {
    const { title, subTitle } = useDialogContext();
    const { icon, text } = title;

    return (
      <TitleContainer displayShadow={displayShadow} style={style} className={className}>
        <CommonTitleContent>
          <DialogTitleContent>
            <ActionsGroup>
              <Flex>
                <DialogTitleContainer>
                  {icon && <Icon kind={icon} />}
                  <RestrictedWidthContainer>
                    <Flex style={{ alignItems: "center", gap: "0 1rem" }}>
                      <TitleText>{titleText || text}</TitleText>
                      {extraTitle}
                    </Flex>
                  </RestrictedWidthContainer>
                </DialogTitleContainer>
                <div>{subTitle}</div>
              </Flex>
            </ActionsGroup>
            <ActionsGroup>
              <CloseDialogIcon />
              {extraActions}
            </ActionsGroup>
          </DialogTitleContent>
          {extra}
          {children}
        </CommonTitleContent>
      </TitleContainer>
    );
  },
);
